import type { ReactNode } from 'react';

export interface CardProps {
  /** 카드 헤더 제목 (없으면 헤더 미표시) */
  title?: ReactNode;
  /** 헤더 우측 액션 영역 */
  actions?: ReactNode;
  /** 본문 패딩 제거 (테이블 등 풀블리드 콘텐츠용) */
  noPadding?: boolean;
  className?: string;
  children: ReactNode;
}

/** 관리자 콘텐츠 카드 (헤더 + 본문) */
export default function Card({ title, actions, noPadding = false, className = '', children }: CardProps) {
  return (
    <section className={['card', className].filter(Boolean).join(' ')}>
      {(title || actions) && (
        <header className="card__header">
          {title ? <h2 className="card__title">{title}</h2> : <span />}
          {actions}
        </header>
      )}
      <div className="card__body" style={noPadding ? { padding: 0 } : undefined}>
        {children}
      </div>
    </section>
  );
}
